import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { AsyncBetslipBetCount } from 'modules/betslip/async';
import { Icon } from 'components';
import Sidebar from '../Sidebar';
import globalMsgs from 'messages';
import useSidebarToggler from './useSidebarToggler';
import arrowDownCircle from 'assets/svg/arrow-down-circle.svg';
import './sidebarToggler.scss';

interface Props {}

const SidebarToggler: React.FC<Props> = () => {
    const {
        handleToggleSidebar,
        isSidebarOpen,
        isFullScreen,
        isAuthorized,
        isMedium,
        ignoreOffsetInTheaterMode,
    } = useSidebarToggler();
    const { formatMessage } = useIntl();

    if (isFullScreen && isMedium) return null;

    return (
        <div
            styleName={cn('container', {
                'is-full-screen': isFullScreen,
                'is-open-sidebar': isSidebarOpen,
                'is-offset-ignored-in-full-screen': ignoreOffsetInTheaterMode,
            })}
        >
            {!isFullScreen && (
                <div styleName="btn" onClick={handleToggleSidebar}>
                    {isSidebarOpen && formatMessage(globalMsgs.hide) + ' '}
                    {formatMessage(globalMsgs.bettingSlip)}
                    <AsyncBetslipBetCount />

                    <Icon glyph={arrowDownCircle} styleName="sidebar-icon" />
                </div>
            )}

            {(isSidebarOpen || isFullScreen) && (
                <Sidebar isAuthorized={isAuthorized} />
            )}
        </div>
    );
};

export default SidebarToggler;
